import React, { useState } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import "./PageSideBarMenu.scss";
import Text from "../Text";
import { Link, useLocation } from "react-router-dom";
import PageSideBarMenuLink from "./PageSideBarMenuLink";

const PageSideBarMenu = props => {
    let sidebar = window.localStorage.getItem("SideBar");
    const location = useLocation();

    const [isActive, setIsActive] = useState(false);
    const [itemsVisibility, setItemsVisibility] = useState(!!sidebar ? JSON.parse(sidebar) : {});

    const toggleItem = name => {
        setItemsVisibility({
            ...itemsVisibility,
            [name]: !itemsVisibility[name],
        });
        window.localStorage.setItem(
            "SideBar",
            JSON.stringify({
                ...itemsVisibility,
                [name]: !itemsVisibility[name],
            })
        );
    };

    let mainClassName = classNames({
        sidebar: true,
        active: !!isActive,
    });

    return (
        <nav id="sidebar" className={mainClassName}>
            <ul className="list-unstyled components">
                {!!props.menuItems
                    ? props.menuItems.items.map((item, index) => {
                          if (!item.label || (!item.href && (!item.items || !item.items.length))) {
                              return "";
                          }
                          return (
                              <li key={index}>
                                  <PageSideBarMenuLink item={item} toggleItem={toggleItem} />
                                  {!!item.items ? (
                                      <ul
                                          className={classNames({
                                              collapse: true,
                                              "list-unstyled": true,
                                              show: !!itemsVisibility[item.id],
                                          })}
                                          id={item.id}
                                      >
                                          {item.items.map((subItem, subIndex) => {
                                              if (!subItem.label) {
                                                  return "";
                                              }
                                              return (
                                                  <li key={subIndex}>
                                                      <div className="menu-tooltip menu-tooltip-right">
                                                          <Link
                                                              id={subItem.href.substring(2)}
                                                              to={subItem.href}
                                                              className={
                                                                  location.pathname.includes(
                                                                      subItem.href
                                                                  )
                                                                      ? "selecteditem"
                                                                      : null
                                                              }
                                                          >
                                                              <div className="long">
                                                                  <Text value={subItem.label} />
                                                              </div>
                                                              {!!subItem.description ? (
                                                                  <span className="tooltiptext">
                                                                      <Text
                                                                          value={
                                                                              subItem.description
                                                                          }
                                                                      />
                                                                  </span>
                                                              ) : (
                                                                  ""
                                                              )}
                                                          </Link>
                                                      </div>
                                                  </li>
                                              );
                                          })}
                                      </ul>
                                  ) : (
                                      ""
                                  )}
                              </li>
                          );
                      })
                    : ""}
            </ul>
        </nav>
    );
};

PageSideBarMenu.propTypes = {
    isVisible: PropTypes.bool,
    menuItems: PropTypes.object,
};

PageSideBarMenu.defaultProps = {
    isVisible: true,
    menuItems: null,
};

export default PageSideBarMenu;
